import React from 'react';

const FullIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 13.75H11.5C15.625 13.75 15.625 13.75 15.625 11.125V8.875C15.625 6.25 15.625 6.25 11.5 6.25H8.5C4.375 6.25 4.375 6.25 4.375 8.875V11.125C4.375 13.75 4.375 13.75 8.5 13.75Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.168 16.6673H5.83464C2.5013 16.6673 1.66797 15.834 1.66797 12.5007V7.50065C1.66797 4.16732 2.5013 3.33398 5.83464 3.33398H14.168C17.5013 3.33398 18.3346 4.16732 18.3346 7.50065V12.5007C18.3346 15.834 17.5013 16.6673 14.168 16.6673Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FullIcon;
